import { TRACKERS_SUB_TYPE } from '../../../utils/constants';
import { BREASTS, BUTTON_SIDES, CRY_TYPES, TIME_OF_THE_DAY } from './models';

export const TrackingConfig = {
  [TRACKERS_SUB_TYPE.SLEEP]: {
    [BUTTON_SIDES.LEFT]: { value: TIME_OF_THE_DAY.DAY },
    [BUTTON_SIDES.RIGHT]: { value: TIME_OF_THE_DAY.NIGHT },
  },
  [TRACKERS_SUB_TYPE.BREAST_FEEDING]: {
    [BUTTON_SIDES.LEFT]: { value: BREASTS.LEFT },
    [BUTTON_SIDES.RIGHT]: { value: BREASTS.RIGHT },
    [BUTTON_SIDES.BOTH]: { value: BREASTS.BOTH },
  },
  [TRACKERS_SUB_TYPE.CRY]: {
    [BUTTON_SIDES.LEFT]: { value: CRY_TYPES.CRY_DAY },
    [BUTTON_SIDES.RIGHT]: { value: CRY_TYPES.CRY_NIGHT },
  },
};

export const getAdditionalInfo = (tracker?: string, side?: string) => {
  if (tracker && side) {
    const trackerConfig = TrackingConfig[tracker];
    if (trackerConfig[side]) {
      return trackerConfig[side].value;
    }
  }
  return '';
};
